<template>
  <div v-if="productData" class="col-xs-12 advCartRow">
    <div class="col-xs-4 col-sm-3 col-lg-2 advCartRowImg">
      <div class="thumbnail_container">
        <div v-if="miniCart" class="thumbnail">
          <a href="#">
            <img :src="imageSrc" :alt="productData.productName">
          </a>
        </div>
        <div v-else class="thumbnail">
          <img :src="imageSrc" :alt="productData.productName">
        </div>
      </div>
    </div>
    <div class="col-xs-8 col-sm-9 col-lg-10 pull-right advCartRowInfo">
      <div class="col-xs-12 col-sm-5 col-md-6 advCartRowName">
        <span v-if="miniCart || disableProductLinks">
            {{ productData.productName }}
            <small v-if="productData.barCodes.length">{{ t('product_barcode') }}: {{ productData.barCodes[0] }}</small>
        </span>
        <span v-else>
          <a :href="productData.productUrl">
            {{ productData.productName }}
            <small v-if="productData.barCodes.length">{{ t('product_barcode') }}: {{ productData.barCodes[0] }}</small>
          </a>
        </span>
        <div v-show="productCodeData.productCodeAttributes.length > 0" class="col-xs-12 advCartRowAttr">
          <span>
            {{ productCodeAttributes }}
          </span>
        </div>
        <div class="col-xs-12 advCartRowMainPrice">
          <span class="AdvPricePerItem">{{ t('price') }} / {{ t('package') }}:</span>
          <span v-html="finalPriceWithSign"></span>
        </div>
      </div>

      <div class="col-xs-12 col-sm-3 col-md-3 advSpinnerRow noPad" v-if="!readOnly">
        <adv-product-input-spinner
          :product-code-id="cartProduct.productCodeId"
          :quantity="cartProduct.quantity"
          v-on:quantity-changed="updateProductQuantity">
        </adv-product-input-spinner>
      </div>
      <div class="col-xs-12 col-sm-3 col-md-3 advSpinnerRow" v-if="readOnly">
        {{ cartProduct.quantity }}
      </div>
      <div class="col-xs-12 col-sm-4 col-md-3 pull-right advCartRowTotal">
        <!--<span v-show="productData.productHasDiscount" class="advCartDiscTtl">{{ t('discount') }}</span>-->
        <!--<span v-show="productData.productHasDiscount" class="advCartDiscPerc">
          <span>{{ productData.productDisclosure }}</span>
        </span>-->
        <span v-show="productData.productHasDiscount" class="col-xs-12 advCartSep"></span>
        <!--<span v-show="productData.productHasDiscount" class="advCartPrevPrice"
              v-html="originalTotalPriceWithSign"></span>-->
        <span class="advCartFinalPrice" v-html="finalTotalPriceWithSign"></span>
      </div>
      <button class="advCartRemove" v-if="!readOnly" v-on:click="removeProductFromCart" :disabled="!onlineStatus">
        <i class="ti-trash"></i>
      </button>
    </div>
    <div class="col-xs-12 text-center helpCartMsg" v-show="cartError && !readOnly">
      <i class="ti-info-alt"></i> {{ cartError }}
    </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import onlineMixin from './mixins/onlineMixin'
import AdvProductInputSpinner from './AdvProductInputSpinner'

export default {
  name: 'AdvCartProductRow',
  components: {
    AdvProductInputSpinner
  },
  mixins: [onlineMixin],
  props: {
    miniCart: {
      type: Boolean,
      default: false
    },
    cartProduct: {
      type: Object
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    disableProductLinks: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      version: '0.0.1'
    }
  },
  computed: {
    cartError () {
      return store.getters.cartProductErrorMsg(this.cartProduct.productCodeId)
    },
    productCodeData () {
      return store.getters.getSelectedProductCodeByCodeId(this.cartProduct.productCodeId)
    },
    originalTotalPriceWithSign () {
      const price = this.productData.productOldPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalPriceWithSign () {
      return (this.productData.productFinalPrice * store.getters.getSelectedCurrency.rate).toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    finalTotalPriceWithSign () {
      const price = this.productData.productFinalPrice * this.cartProduct.quantity * store.getters.getSelectedCurrency.rate
      return price.toFixed(2) + store.getters.getSelectedCurrency.symbol
    },
    productData () {
      return store.getters.getProductById(this.cartProduct.productId)
    },
    imageSrc () {
      return this.productData.hasOwnProperty('images') ? this.productData.images[this.cartProduct.productCodeId].find(item => item.is_main === '1')['small'] : store.getters.noImage
    },
    productCodeAttributes () {
      return this.productCodeData.productCodeAttributes.reduce((acc, item) => {
        if (acc !== '') {
          acc += ' - '
        }

        acc += store.getters.attributeName(item)
        return acc
      }, '')
    }
  },
  methods: {
    removeProductFromCart () {
      store.dispatch('addToCartClicked', { productCodeId: this.cartProduct.productCodeId, quantity: 0 })
    },
    updateProductQuantity (quantity) {
      store.dispatch('addToCartClicked', { productCodeId: this.cartProduct.productCodeId, quantity: quantity })
    }
  }
}
</script>
